export default __webpack_public_path__ + "static/media/9.8e8db608.png";